export default {
  ScreenshotSuccess: "Ekran görüntüsü başarıyla kaydedildi",
  ScreenshotFailed: "Ekran görüntüsü alınamadı",
  Download: "İndir",
  ECVScreenshot: "ECV Ekran Görüntüsü",
  WholeScreenshot: "Tüm Ekran Görüntüsü",
  self: "Kendi",
  hidden: "Gizli",
  visible: "Görünür",
  "admin-panel": "Admin Paneli",
  agent: "Agent",
  supervisor: "Supervizor",
  "ecv-window": "ECV Penceresi",
  "whole-screens": "Tüm Ekranlar",
};
